import React from 'react'
import { Card, P } from '@fareye/ui'
export default function Epod() {
  return (
    <Card style={{ border: '0px' }} bodyStyle={{ padding: '18px' }} variant="m">
      <P variant="h5" style={{ marginBottom: '18px', marginTop: '5px' }}>
        EPOD
      </P>
    </Card>
  )
}
